import { useRecordContext } from "ra-core";

import { AsideSection } from "../../atomic-crm/misc/AsideSection";
import { PropertyRow } from "../record/PropertyRow";
import {
  useCustomFieldDefinitions,
  type CustomFieldDefinition,
  type CustomFieldEntity,
} from "./useCustomFields";

/**
 * Read-only custom-field values on a record detail sidebar. Renders nothing
 * when the workspace has no fields defined for the entity.
 */
export const CustomFieldsSection = ({
  entity,
}: {
  entity: CustomFieldEntity;
}) => {
  const { data: definitions = [] } = useCustomFieldDefinitions(entity);
  const record = useRecordContext<{
    custom_fields?: Record<string, unknown>;
  }>();

  if (definitions.length === 0 || !record) return null;
  const values = record.custom_fields ?? {};

  return (
    <AsideSection title="Custom fields">
      {definitions.map((definition) => (
        <PropertyRow key={definition.id} label={definition.label}>
          {formatValue(definition, values[definition.key])}
        </PropertyRow>
      ))}
    </AsideSection>
  );
};

const formatValue = (
  definition: CustomFieldDefinition,
  value: unknown,
): string => {
  if (value == null || value === "") return ", ";
  switch (definition.field_type) {
    case "boolean":
      return value ? "Yes" : "No";
    case "date":
      return new Date(String(value)).toLocaleDateString();
    default:
      return String(value);
  }
};
